import { FC } from 'react'
import styleUtils from 'shared-components/styles/util.module.css'
import { DSNCAboutExpert } from 'shared-definitions/types'
import AboutExpert from '../ui/AboutExpert'

interface NCAboutExpertProps {
  data: DSNCAboutExpert
}

const NCAboutExpert: FC<NCAboutExpertProps> = ({ data }) => (
  <AboutExpert {...data} className={styleUtils.nc} />
)

export default NCAboutExpert
